import React from 'react';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {
  Box,
  MenuItem,
  Pagination,
  PaginationItem,
  Select,
  Typography,
  useMediaQuery,
} from '@mui/material';

const OlcTablePagination = ({
  count,
  page,
  pageSize,
  pageSizes = [20, 50, 100],
  onPageChange,
  onPageSizeChange,
  from,
  to,
  total,
  loading = false,
  showPageSize = true,
}) => {
  const isCompactPagination = useMediaQuery('(max-width: 900px)');

  return (
    <Box
      className={`generalPaginationWrapper olcTablePagination ${
        loading ? 'olcTablePaginationLoading' : ''
      }`}
      aria-hidden={loading || undefined}
    >
      <Pagination
        count={Math.max(1, count || 1)}
        variant="outlined"
        shape="rounded"
        onChange={onPageChange}
        page={Math.max(1, page || 1)}
        disabled={loading}
        siblingCount={isCompactPagination ? 0 : 1}
        boundaryCount={1}
        renderItem={(item) => (
          <PaginationItem
            slots={{
              previous: ArrowBackIosNewIcon,
              next: ArrowForwardIosIcon,
            }}
            {...item}
          />
        )}
      />
      {showPageSize ? (
        <Select
          className="pageSelect"
          size="small"
          inputProps={{ 'aria-label': 'Results per page' }}
          value={pageSize}
          onChange={onPageSizeChange}
          disabled={loading}
          MenuProps={{ classes: { paper: 'paginationPageSizeMenu' } }}
        >
          {pageSizes.map((size) => (
            <MenuItem key={size} value={size}>
              {size}
            </MenuItem>
          ))}
        </Select>
      ) : null}
      <Typography>
        Showing {total ? from : 0} to {total ? Math.min(to, total) : 0} of {total} results
      </Typography>
    </Box>
  );
};

export default OlcTablePagination;
